import React from "react";
import { useTranslation } from "react-i18next";
import { PrimaryText } from "@components";

const CaddyPolicy = ({ className = "" }) => {
  const { t } = useTranslation("common");

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <PrimaryText className="text-textColor text-[16px]">
        {t("caddyPolicy.title")}
      </PrimaryText>
      <PrimaryText className="text-textColor text-[16px]">
        {t("caddyPolicy.effective")}
      </PrimaryText>
      <PrimaryText className="text-textColor text-[16px]">
        {t("caddyPolicy.intro")}
      </PrimaryText>
      <div className="flex flex-col gap-1">
        <PrimaryText className="text-textColor text-[16px]">
          {t("caddyPolicy.optionJunior")}
        </PrimaryText>
        <PrimaryText className="text-textColor text-[16px]">
          {t("caddyPolicy.optionSingle")}
        </PrimaryText>
        <PrimaryText className="text-textColor text-[16px]">
          {t("caddyPolicy.optionForecaddie")}
        </PrimaryText>
      </div>
      <PrimaryText className="text-textColor text-[16px]">
        {t("caddyPolicy.default")}
      </PrimaryText>
    </div>
  );
};

export default CaddyPolicy;
